@if (pills.length) {
  <!-- w-full + min-w-0 give the row a definite width to wrap against. Without them it sizes
       to its content, and an autosize sidenav container then widens the whole filter panel
       to fit the pills on one line. -->
  <div class="flex flex-wrap w-full min-w-0 gap-x-5 gap-y-5">
    @for (pill of pills; track pill.Value) {
      <button mat-button
        class="flex items-center min-w-0 px-8 py-2 text-xs font-semibold uppercase rounded-full is-sm is-mint"
        [attr.aria-label]="'Remove ' + pill.Label + ' filter'"
        [title]="pill.Label"
        (click)="removed.emit(pill.Value)" [disabled]="disabled">
        <span class="truncate min-w-0">{{pill.Label}}</span>
        <i class="material-icons flex-shrink-0 ml-2" style="font-size: 1.4rem">close</i>
      </button>
    }
  </div>
}
